module.exports = __webpack_public_path__ + "media/images/icons/menu-ec18615a86ce1c207830d4fb14207e01.svg";